<style lang="scss" src="./VerAfiliacion.scss"></style>
<template src="./VerAfiliacion.html"></template>

<script>
import {Breadcrumb, BreadcrumbItem} from "element-ui";
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import moment from "moment";
import {requestAfiliacionMixin} from "@/api/ciudadano/afiliacionApi";
import {NotifyMixin} from "@/mixins/NotifyMixin";
import AfiliacionDetail from "@/components/Shared/AfiliacionDetail/AfiliacionDetail";

export default {
  name: "VerAfiliacion",
  components: {
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    AfiliacionDetail,
  },
  mixins: [
    ScreenSizeMixin,
    requestAfiliacionMixin,
    NotifyMixin
  ],
  data: () => ({
    loading: true,
    errored: false,
    inRoute: false,
    model: {
      id: "",
      rut: "",
      nombreCompleto: "",
      domicilio: "",
      fechaNacimiento: '',
      email: "",
      telefonoMovil: "",
      telefonoFijo: "",
      partidosSeleccionado: '',
      estado: "",
      estadoCodigo: 0,
      fecha: '',
      hora: ''
    },
  }),
  props: {
    idAfiliacion: {
      type: String,
      required: false
    }
  },
  beforeMount() {
    this.getIdAfiliacion()
    this.afiliacion()
  },
  computed: {
    getShadow: function() {
      if (this.$route.params.hasOwnProperty('id')) {
        return 'always'
      }
      return 'never'
    }
  },
  methods: {
    getIdAfiliacion() {
      if (this.$route.params.hasOwnProperty('id')) {
        this.model.id = this.$route.params.id
        this.inRoute = true
      } else {
        this.model.id = this.idAfiliacion
      }
    },
    afiliacion() {
      this.getAfiliacion(this.model.id)
        .then(response => {
          this.$log.debug('getAfiliacion', this.model.id, response.data.statusCode)
          if (response.data.statusCode === 200) {
            const data = JSON.parse(response.data.datos);
            this.$log.debug(data)

            this.convertDataToModel(data)

            this.errored = false
          } else {
            this.messageError(response.data.statusCode)
          }
        })
        .catch(err => {
          this.$log.fatal('getAfiliacion', err, this.model.id)
          this.messageError(err.request.status)
        })
        .finally(() => {
          this.loading = false
        })
    },
    convertDataToModel(data = {}) {
      this.model.rut = data.cedula
      this.model.nombreCompleto = data.nombrecompleto
      this.model.fechaNacimiento = moment(data.fechanacimiento, "YYYYMMDD").format('DD-MM-YYYY')
      this.model.email = data.email
      this.model.telefonoMovil = data.telefonomovil
      this.model.telefonoFijo = data.telefonofijo
      this.model.partidosSeleccionado = data.partidonombre

      this.model.estado = data.estado
      this.model.estadoCodigo = data.estadocodigo

      const mfecha = moment.utc(data.fecha).local()
      this.model.fecha = mfecha.format('DD-MM-YYYY')
      this.model.hora = mfecha.format('h:mm a')
      this.model.domicilio = data.domicilio
    },
    messageError(statusCode) {
      this.errored = true
      let message = 'Ocurrió un error inesperado al cargar la afiliación'
      if (statusCode === 404) {
        message = 'La afiliación no existe'
      }
      this.showError(message)
      this.$emit('on-error-close', true)
    },
  }
}
</script>
